import { Component, OnInit } from '@angular/core';

declare var $: any;;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  name: any;
  email: any;
  password: any;
  location: any;
  constructor() { }

  ngOnInit(): void {
  }

  profile() {
    $("#activation_section").removeClass("hidden").addClass("visible");
    $("#profile_section").removeClass("visible").addClass("hidden");
  }
  activation() {
    $("#activation_section").removeClass("visible").addClass("hidden");
    $("#pairing_section").removeClass("hidden").addClass("visible");
  }

  pairing() {
    $("#pairing_section").removeClass("visible").addClass("hidden");
    $("#details_section").removeClass("hidden").addClass("visible");
  }

  details() {
    $("#all_done_section").removeClass("hidden").addClass("visible");
    $("#details_section").removeClass("visible").addClass("hidden");
  }
}
